"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ButtonGroup = require("./ButtonGroup.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
  var handleClose = _ref.handleClose,
      handleSubmit = _ref.handleSubmit,
      isSubmitting = _ref.isSubmitting,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "white" : _ref$text,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? "#62BA09" : _ref$background,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$textTransform = _ref.textTransform,
      textTransform = _ref$textTransform === void 0 ? "uppercase" : _ref$textTransform,
      wrapperStyle = _ref.wrapperStyle;
  return /*#__PURE__*/_react.default.createElement(_ButtonGroup.GroupButtonView, {
    wrapperStyle: wrapperStyle
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: "Cancel",
    onClick: handleClose,
    text: "#407A28",
    background: background,
    textTransform: textTransform,
    size: size,
    variant: "outlined",
    "data-testid": "cancel"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "spacer"
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleSubmit,
    disabled: isSubmitting,
    label: "Save",
    text: text,
    background: background,
    textTransform: textTransform,
    size: size,
    "data-testid": "submit"
  }));
};

var _default = ButtonGroup;
exports.default = _default;

//# sourceMappingURL=ButtonGroup.js.map